/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBritaxBuyboxSwatchesData } from './britax-buybox-swatches.data';
import { IBritaxBuyboxSwatchesProps } from './britax-buybox-swatches.props.autogenerated';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
export interface IBritaxBuyboxSwatchesPropsView extends IBritaxBuyboxSwatchesProps<IBritaxBuyboxSwatchesData> {
    swatches?: React.ReactNode;
    AccountProfile?: IModuleProps;
}
export interface IBritaxBuyboxSwatchesViewProps extends IBritaxBuyboxSwatchesPropsView {}

/**
 *
 * BritaxBuyboxSwatches component
 * @extends {React.PureComponent<IBritaxBuyboxSwatchesProps<IBritaxBuyboxSwatchesData>>}
 */
class BritaxBuyboxSwatches extends React.PureComponent<IBritaxBuyboxSwatchesProps<IBritaxBuyboxSwatchesData>> {
    public constructor(props: IBritaxBuyboxSwatchesProps<IBritaxBuyboxSwatchesData>) {
        super(props);
    }
    /**
     * Renders the sign in button.
     * @param user - Request context user.
     * @param resources - Resources.
     * @returns React Node.
     */
    private _getSigninButton(props: IBritaxBuyboxSwatchesPropsView): React.ReactNode | undefined {
        const {
            swatchesImage_1,
            swatchesLabel_1,
            swatchesLink_1,
            swatchesImage_2,
            swatchesLabel_2,
            swatchesLink_2,
            swatchesImage_3,
            swatchesLabel_3,
            swatchesLink_3,
            swatchesImage_4,
            swatchesLabel_4,
            swatchesLink_4,
            swatchesImage_5,
            swatchesLabel_5,
            swatchesLink_5,
            title
        } = props.config;
        return (
            <div className='ms-swatches'>
                <div className='ms-swatches__title'>{title ? title.replace(/\s+/g, '') : ''}</div>
                <div className='ms-swatches__images'>
                    {swatchesImage_1 && (
                        <a href={swatchesLink_1?.destinationUrl}>
                            <figure className='ms-swatches__link_image'>
                                <img src={swatchesImage_1.src} alt={swatchesLabel_1} />
                                <figcaption className='ms-swatches__link_caption'>{swatchesLabel_1}</figcaption>
                            </figure>
                        </a>
                    )}
                    {swatchesImage_2 && (
                        <a href={swatchesLink_2?.destinationUrl}>
                            <figure className='ms-swatches__link_image'>
                                <img src={swatchesImage_2.src} alt={swatchesLabel_2} />
                                <figcaption className='ms-swatches__link_caption'>{swatchesLabel_2}</figcaption>
                            </figure>
                        </a>
                    )}
                    {swatchesImage_3 && (
                        <a href={swatchesLink_3?.destinationUrl}>
                            <figure className='ms-swatches__link_image'>
                                <img src={swatchesImage_3.src} alt={swatchesLabel_3} />
                                <figcaption className='ms-swatches__link_caption'>{swatchesLabel_3}</figcaption>
                            </figure>
                        </a>
                    )}
                    {swatchesImage_4 && (
                        <a href={swatchesLink_4?.destinationUrl}>
                            <figure className='ms-swatches__link_image'>
                                <img src={swatchesImage_4.src} alt={swatchesLabel_4} />
                                <figcaption className='ms-swatches__link_caption'>{swatchesLabel_4}</figcaption>
                            </figure>
                        </a>
                    )}
                    {swatchesImage_5 && (
                        <a href={swatchesLink_5?.destinationUrl}>
                            <figure className='ms-swatches__link_image'>
                                <img src={swatchesImage_5.src} alt={swatchesLabel_5} />
                                <figcaption className='ms-swatches__link_caption'>{swatchesLabel_5}</figcaption>
                            </figure>
                        </a>
                    )}
                </div>
            </div>
        );
    }
    public render(): JSX.Element | null {
        const viewprops: IBritaxBuyboxSwatchesPropsView = {
            ...this.props,
            swatches: this._getSigninButton(this.props)
        };

        return this.props.renderView(viewprops);
    }
}

export default BritaxBuyboxSwatches;
